/* eslint-disable no-unused-vars */
import { getLocalStorageApi, STORAGE_KEYS } from 'utilities/localStorage';

const defaultOrgLocalStorage = getLocalStorageApi(STORAGE_KEYS.DEFAULT_ORG, {
  id: "9a1a1673-6926-41fa-9d71-a5aad6f67cb6"
});

const selectedOrg = localStorage.getItem('selectedOrganizationId');

const blankUser = {
  id: '',
  name: '',
  email: '',
  phone: '',
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    addressId: ''
  },
  applicatorLicenseNumber: '',
  applicatorLicenseExpirationDateEpoch: '',
  applicatorLicenseExpirationDate: '',
  notes: ''
};

export default blankUser;
